import { ConsumableGroup } from '../interfaces/dtos/ConsumableGroup';
import { IConsumableItem } from '../interfaces/dtos/IConsumableItem';
import { IProductDisplayItem } from '../interfaces/dtos/IProductDisplayItem';
import { IProductDisplayMenu } from '../interfaces/dtos/IProductDisplayMenu';
import { UnitOfMeasureTypes } from '../enumerations/unit-of-measure-type';

interface IConsumerGroupConverter {
  convertMenu: (consumerGroup: ConsumableGroup, menuIndex: number) => IProductDisplayMenu;
  convertItem: (consumerItem: IConsumableItem, itemIndex: number) => IProductDisplayItem;
}

export const ConsumerGroupConverter = (): IConsumerGroupConverter => {
  const convertMenu = (menuData: ConsumableGroup, menuIndex: number): IProductDisplayMenu => {
    const menu: IProductDisplayMenu = {};

    menu.Id = menuData.id || `${menuIndex}`;
    menu.Name = menuData.description || 'N/A';
    menu.Image = menuData.frontBase64Image || '';
    menu.ImageUrl = menuData.imageUrl;
    if (menuData.consumableSubGroups && menuData.consumableSubGroups?.length > 0) {
      menu.SubMenus = menuData.consumableSubGroups.map(
        (menu, index): IProductDisplayMenu => {
          return convertMenu(menu, index);
        },
      );
    } else if (menuData.consumableItems && menuData.consumableItems?.length > 0) {
      menu.Items = menuData.consumableItems.map(
        (item, index): IProductDisplayItem => {
          return convertItem(item, index);
        },
      );
    }

    return menu;
  };

  const convertItem = (itemData: IConsumableItem, itemIndex: number): IProductDisplayItem => {
    const item: IProductDisplayItem = {};

    item.Id = itemData.id || `${itemIndex}`;
    item.Name = itemData.description || 'N/A';
    item.Price = itemData.price || 0;
    item.UnitOfMeasure = itemData.unitOfMeasureCode || UnitOfMeasureTypes.Each;
    item.Image = itemData.base64Image || '';
    item.ExternalId = itemData.externalId || '';
    item.ImageUrl = itemData.imageUrl;
    item.EmeraldImageUrl = itemData.emeraldImageUrl;
    item.Quantity = itemData.regularSaleUnitPrice?.quantity;

    return item;
  };

  return {
    convertMenu: convertMenu,
    convertItem: convertItem,
  };
};
